module.exports = __webpack_public_path__ + "img/5.077aa166.jpg";